<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "ViolationReportsList",

    mixins: [ListDefault],

    data() {
        return {
            lang: this.$ml.get('pages.violationReports'),

            isVisibleCreateButton: false,
            isVisibleEditButton: false,

            filter: {
                reasons: { value: null, type: 'select', options: [] },
                artifact_id: { value: null, type: 'select', options: [] },
                user_id: { value: null, title_key: 'name', type: 'select', options: [] },
                artifact_owner_id: { value: null, title_key: 'name', type: 'select', options: [] },
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'reasons', is_sort: false, classes: 'text-l' },
                { key: 'detail', is_sort: false, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'artifact_id', is_sort: true, classes: 'text-l' },
                { key: 'artifact_owner_id', is_sort: true, classes: 'text-l' },
                { key: 'created_at', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                'user_id': { type: 'function', function: this.getUser },
                'reasons': { type: 'function', function: this.getReason },
                'detail': { type: 'function', function: this.getDetail },
                'artifact_id': { type: 'function', function: this.getArtifact },
                // 'artifact_id': { type: 'function', function: this.getArtifact },
                'artifact_owner_id': { type: 'function', function: this.getOwner },
                'created_at': { type: 'function', function: this.getDate },
            },

            apiList: this.$store.getters.getApiUrl('violationReports'),
            pageRoute: 'violation-reports',
        }
    },

    methods: {
        getArtifact(item) {
            if (! item.artifact) {
                return 'DELETED'
            }
            let link = this.$router.resolve({name: 'artifact.edit', params: {id: item.artifact.id}})
            return `<a href="${link.href}" class="link">${item.artifact.title}</a>`
        },
        getReason(item) {
            if (!item.reasons?.length) {
                return ''
            }
            return item.reasons.map(reason => reason?.length > 15 ? reason.slice(0, 15) + '...' : reason).join(', ')
        },
        getDetail(item) {
            return item.detail?.length > 25 ? item.detail.slice(0, 25) + '...' : item.detail
        },
        getUser(item) {
            if (! item.user) {
                return 'DELETED'
            }
            let link = this.$router.resolve({name: 'user.edit', params: {id: item.user_id}})
            return `<a href="${link.href}" class="link">@${item.user.name}</a>`
        },
        getOwner(item) {
            if (! item.owner) {
                return 'DELETED'
            }
            let link = this.$router.resolve({name: 'user.edit', params: {id: item.artifact_owner_id}})
            return `<a href="${link.href}" class="link">@${item.owner.name}</a>`
        },
        getDate(item) {
            return item.created_at ? this.$func.getDateTime(item.created_at) : null
        },
    },

    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    },
}
</script>

